<template>
  <div id="wrapper" class="noheader" v-if="view === 'suggestion'">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>意見反映</p>
          <span></span>
        </div>
        <a v-if="notFromLine" class="arr" @click.prevent="$router.replace(from)"
          ><div class="inner"></div
        ></a>
      </div>
      <div class="suggestionBox">
        <div class="tabs">
          <a :class="active.婦產科" @click="changeTab('婦產科')"
            ><p>婦產科</p></a
          >
          <a :class="active.小兒科" @click="changeTab('小兒科')"
            ><p>小兒科</p></a
          >
          <a :class="active.住院部" @click="changeTab('住院部')"
            ><p>住院部</p></a
          >
          <a :class="active.月子中心" @click="changeTab('月子中心')"
            ><p>月子中心</p></a
          >
        </div>
        <p class="txt">訊息內容</p>
        <div class="formBox">
          <form action="javascript:void(0);">
            <textarea placeholder="訊息輸入" v-model="context"></textarea>
            <input
              @click="submit"
              type="submit"
              class="submitBtn"
              value="確認送出"
            />
          </form>
        </div>
        <p class="captionTxt">
          歡迎您提供任何意見或建議，我們非常重視這些寶貴的建議或是想法，您的指教是我們源源不斷進步的動力。
        </p>
        <div class="btns">
          <a class="btn" @click="routeToSurvey"
            ><div class="txt">{{ surveyType }}就診滿意度調查</div>
            <div class="icon">
              <img
                src="@/assets/images/suggestion_icon_heart.svg"
                width="18"
              /></div
          ></a>
          <a class="btn" @click="toReport"
            ><div class="txt">回報軟體問題</div>
            <div class="icon">
              <img
                src="@/assets/images/suggestion_icon_book.svg"
                width="18"
              /></div
          ></a>
          <a class="btn" @click="view = 'contact'"
            ><div class="txt">聯絡我們</div>
            <div class="icon">
              <img
                src="@/assets/images/suggestion_icon_chat.svg"
                width="16"
              /></div
          ></a>
        </div>
      </div>
    </div>
  </div>

  <div id="wrapper" class="noheader" v-else-if="view === 'report'">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>回報軟體問題</p>
          <span></span>
        </div>
        <a class="arr" @click.prevent="back"><div class="inner"></div></a>
      </div>
      <div class="suggestionBox">
        <div class="tabs none">
          <a><p></p></a>
          <a><p></p></a>
          <a><p></p></a>
          <a><p></p></a>
        </div>
        <p class="txt">訊息內容</p>
        <div class="formBox">
          <form action="javascript:void(0);">
            <textarea placeholder="訊息輸入" v-model="context"></textarea>
            <input
              type="submit"
              class="submitBtn"
              value="確認送出"
              @click="submit"
            />
          </form>
        </div>
        <p class="captionTxt">
          歡迎您提供任何意見或建議，我們非常重視這些寶貴的建議或是想法，您的指教是我們源源不斷進步的動力。
        </p>
      </div>
    </div>
  </div>

  <div id="wrapper" class="noheader" v-else-if="view === 'contact'">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>聯繫我們</p>
          <span></span>
        </div>
        <a class="arr" @click.prevent="back"><div class="inner"></div></a>
      </div>
      <div class="contactusBox">
        <div class="data">
          <h2>木生婦產科診所</h2>
          <div class="line"></div>
          <p>台北市長安東路二段90號</p>
        </div>
        <div class="transBox">
          <div class="box">
            <p class="type">捷運</p>
            <p class="txt">
              中和新蘆線&nbsp;至松江南京站2號出口備有無障礙電梯出來步行約5分鐘。
            </p>
          </div>
          <div class="box">
            <p class="type">停車</p>
            <p class="txt">建議可利用建國高架停車場2長榮飯店中興嘟嘟房</p>
          </div>
        </div>
        <div class="data">
          <h2>
            電話預約專線<a href="tel:0225012312"
              ><br />
              02-2501-2312</a
            >
          </h2>
          <h2>
            信箱聯繫我們<a
              @click="openWindow('mailto:reception@musoonclinic.com.tw', true)"
            >
              reception@musoonclinic.com.tw
            </a>
          </h2>
          <div class="line"></div>
          <p>
            預約受理時間<br />早上&nbsp;08:50&nbsp;至晚間&nbsp;20:30&nbsp;歡迎來電預約
          </p>
        </div>
        <div class="socialBtns clearfix">
          <a><img src="@/assets/images/contactus_icon_line.svg" width="50"/></a>
          <a><img src="@/assets/images/contactus_icon_fb.svg" width="50"/></a>
        </div>
      </div>
    </div>
  </div>
  <modal v-if="modal.display" @close="modal.display = false">
    <template #header>{{ modal.header }}</template>
    <template #body>{{ modal.body }}</template>
  </modal>
</template>

<script>
import liff from "@line/liff";
import api from "../api/index";

export default {
  data() {
    return {
      view: "suggestion",
      active: {
        婦產科: "active",
        小兒科: null,
        住院部: null,
        月子中心: null
      },
      category: "婦產科",
      context: "",
      modal: {}
    };
  },
  computed: {
    notFromLine() {
      return !this.from.includes("FeedBack");
    },
    member() {
      return this.$store.state.member;
    },
    from() {
      return this.$store.state.from;
    },
    surveyType() {
      if (this.category === "婦產科" || this.category === "小兒科") {
        return "門診";
      }
      if (this.category === "月子中心") {
        return "產後照護";
      }
      return "病房";
    }
  },
  methods: {
    openWindow(url, external) {
      liff.openWindow({
        url: url,
        external: external
      });
    },
    changeTab(tab) {
      const keys = Object.keys(this.active);
      for (let i = 0; i < keys.length; i++) {
        this.active[keys[i]] = null;
      }
      this.active[tab] = "active";
      this.category = tab;
    },
    routeToSurvey() {
      if (this.category === "婦產科" || this.category === "小兒科") {
        this.$router.replace("./SurveyVisit");
      }
      if (this.category === "月子中心") {
        this.$router.replace("./SurveyPostpartum");
      }
      if (this.category === "住院部") {
        this.$router.replace("./SurveyRoom");
      }
    },
    submit() {
      if (this.context.trim() === "") {
        this.modal = {
          display: true,
          header: "警示",
          body: "請勿空白"
        };
      } else {
        console.log(this.category, this.context);
        api.feedback
          .create({
            type: this.category,
            jwt: this.member.jwt,
            content: this.context
          })
          .then(data => {
            console.log(data);
            this.modal = {
              display: true,
              header: "意見反映",
              body: "謝謝您～我們已收到您寶貴的建議。"
            };
            this.context = "";
          })
          .catch(error => {
            this.modal = {
              display: true,
              header: "意見反映",
              body:
                "很抱歉，您的訊息儲存時發生異常，請重新操作或與我們聯繫，造成不便還請見諒。" +
                error
            };
          });
      }
    },
    back() {
      this.category = "婦產科";
      this.view = "suggestion";
      this.context = "";
    },
    toReport() {
      this.category = "軟體問題";
      this.view = "report";
      this.context = "";
    }
  }
};
</script>
